import { render, staticRenderFns } from "./JournalType.vue?vue&type=template&id=8adcf822&scoped=true&"
import script from "./JournalType.vue?vue&type=script&lang=js&"
export * from "./JournalType.vue?vue&type=script&lang=js&"
import style0 from "./JournalType.vue?vue&type=style&index=0&id=8adcf822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adcf822",
  null
  
)

export default component.exports